import * as types from "../constants";

const initialState = {
    shortenUrl: false,
};

export default function reducer(state = initialState, actions) {
    switch (actions.type) {
        case types.SHORTEN_URL_SMS:
            return {
                ...state,
                shortenSMSUrl: actions.payload.shortUrl
            };
        case types.SHORTEN_URL_SMS_ERROR:
            return {
                ...state,
                shortenSMSUrl: false

            };
        case types.SHORTEN_URL_EMAIL:
            return {
                ...state,
                shortenEMAILUrl: actions.payload.shortUrl
            };
        case types.SHORTEN_URL_EMAIL_ERROR:
            return {
                ...state,
                shortenEMAILUrl: false

            };

        default:
            return state;
    }
}
